import pdfPageTitle from './PDFPageTitle';
import metricCharts from './PDFMetricChartContainer';
import primaryMetricChart from './PDFPrimaryMetric';
import linkedToList from './PDFLinkedToList';
import links from './PDFLinks';

export default (
    printSection, {
        title: titleOptions = {},
        description: descriptionOptions = {},
        // Options for layout:
        metrics: metricsOptions = {},
        primaryMetric: primaryMetricOptions = {},
        linkedTo: linkedToOptions = {},
        links: linksOptions = {},
        // content div for all 3 non-metric elements
        content: contentOptions = {}
    } = {}
) => {
    const { title = '', storyContent: description, colorClass = 'print.primary.7', primaryBeliefMetric, disclaimer, icon } = printSection;
    const page = pdfPageTitle({ title, description, colorClass, icon }, { title: { h: 'h-1', ...titleOptions }, description: descriptionOptions });
    page.disclaimer = disclaimer && {
        mt: 10,
        font: { colour: colorClass },
        text: `* ${disclaimer}`
    };
    page.metrics = metricCharts(printSection, metricsOptions);
    page.content = {
        position: 'col-2',
        y: primaryBeliefMetric ? 'h-8-1/4' : 'h-9',
        primaryMetric: primaryMetricChart(printSection, primaryMetricOptions),
        linkedTo: linkedToList(printSection, linkedToOptions),
        links: links(printSection, linksOptions),
        ...contentOptions
    };
    return page;
};
